import type { IOrderComponentDescriptor } from './interfaces/MetadataInterfaces';

export const SUPPORTED_ORDER_COMPONENT_CAPABILITIES: ReadonlySet<string> =
  new Set([
    'order-components-v1',
    'order-components-measurements-title-check-v1',
    'order-components-conditional-consent-v1',
    'order-component-visibility-in-v1',
  ]);

export const isOrderComponentSupported = (
  descriptor: IOrderComponentDescriptor
): boolean =>
  SUPPORTED_ORDER_COMPONENT_CAPABILITIES.has(
    descriptor.requiredApplicationCapability
  );

export const supportsVisibilityAllowlist = (
  descriptor: IOrderComponentDescriptor
): boolean =>
  SUPPORTED_ORDER_COMPONENT_CAPABILITIES.has(
    descriptor.visibilityApplicationCapability
  ) &&
  descriptor.visibilityOperators.some(
    (operator) => operator.toLowerCase() === 'in'
  );
